import React, { FC, useState } from 'react';
import Tracking from '@vromo/analytics';
import Color from 'color';
import { Graph } from '@vromo/api/graph';
import ProfileImage from '@vromo/ui/components/ProfileImage';
import { withTheme } from '@emotion/react';

import { AvailableContactProtocol, ContactMethod, ContactProtocol, Job, Vehicle } from '@vromo/models';
import { CampaingContactButton } from './components';
import styled from '@emotion/styled';
import { qaLabelTrackingLink } from '../../../common-qa-labels/tracking-link';


const DetailsAndContact = withTheme(styled.div`
    color: ${({ theme }) => Color(theme.background).isLight() ?
        '#111111' :
        '#EFEFEF'
    };
    padding: 8px;
    font-size: 14px;
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: center;
`)





interface DriverDetailsProps {
    vehicle: Vehicle;
    job: Job;
    host: string;
    auth: string;
}

const DriverDetails: FC<DriverDetailsProps> = ({ vehicle, job, host, auth }) => {

    const [contactDetails, setContactDetails] = useState<AvailableContactProtocol>({} as AvailableContactProtocol);
    const [isLoading, setIsLoading] = useState(false)

    async function contactDriver(method: ContactMethod) {
        if (isLoading)
            return Promise.resolve()

        Tracking.track(`'${method}' Driver Button Pressed`)

        if (contactDetails[method]) {
            window.open(`${ContactProtocol[method]}:${contactDetails[method]}`, '_blank');
        }

        try {
            setIsLoading(true)
            const { items: [contactMethod] } = await new Graph(host).root
                .track(auth, job.id!)
                .job()
                .contact()
                .channels()
                .post({ items: [{ methods: [method] }] })

            setContactDetails({
                ...contactDetails,
                [method]: contactMethod!.phone
            });
            window.open(`${ContactProtocol[method]}:${contactMethod!.phone}`, '_blank');

        } catch (err) {
            console.error(err)
            alert('Sorry, you are unable to contact the driver at this point in time');
        }
        finally {
            setIsLoading(false)
        }
    }

    return (
        <DetailsAndContact data-testid={qaLabelTrackingLink.contactDetailsDiv}>
            <ProfileImage
                url={vehicle?.driver?.avatar?.url}
                user={vehicle?.driver}
                size={32}
                style={{
                    flexShrink: 0,
                    marginRight: 8
                }}
            />
            <div data-testid={qaLabelTrackingLink.predefinedDeliveryText}>
                Your driver is delivering your order{' '}
                {job.site?.contact?.name &&
                    <span>
                        from <strong data-testid={qaLabelTrackingLink.siteText}> {job.site.contact.name} </strong>
                    </span>
                }
            </div>
            <CampaingContactButton
                data-testid={qaLabelTrackingLink.phoneBtn}
                onClick={() => contactDriver('phone')}
                icon="phone"
                show={
                    job.contact!.showMaskedPhone({ type: "phone", masking: job.campaign?.link?.proxyEnabled }) &&
                    vehicle?.driver!.contact!.phone !== null
                }
            />
            <CampaingContactButton
                data-testid={qaLabelTrackingLink.smsBtn}
                onClick={() => contactDriver('sms')}
                icon="comment-alt-lines"
                show={
                    job.contact!.showMaskedPhone({ type: "sms", masking: job.campaign?.link?.proxyEnabled }) &&
                    vehicle?.driver!.contact!.phone !== null
                }
            />
        </DetailsAndContact>
    );
}

export default DriverDetails
